import { render } from "./PageLoading.vue?vue&type=template&id=564d8da3&scoped=true"
const script = {}

import "./PageLoading.vue?vue&type=style&index=0&id=564d8da3&scoped=true&lang=css"

import exportComponent from "D:\\AppV5\\DangKyXetTuyen\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564d8da3"]])

export default __exports__